export class InformationType {
  generalCountryInformationTypeId?: number;
  name?: string;
  constructor(info: InformationType) {
    this.generalCountryInformationTypeId = info.generalCountryInformationTypeId;
    this.name = info.name;
  }
}
